/// <reference types="@types/googlemaps" />
import { Component, OnInit, ElementRef, ViewChild, NgZone, Input, Output, Renderer2, Inject } from '@angular/core';
import { GOOGLE_API_KEY, GOOGLE_ANALYTIC_ID, MAIN_TITLE, DESCRIPTION, ENV_TYPE, IMAGES_URL, WEB_LINK, IOS_APP_LINK } from 'src/app/shared/constants/constants';
import { ApiService } from '../shared/service/api.service';
import { LocalStorageService } from '../shared/service/localstorage.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserSearchDeliveryLocationInfo, LocationResponseData, GeoLocationData, DeliveryLocationResponseData } from '../shared/interfaces/delivery';
import { UserService } from '../shared/service/user.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { tns, TinySliderInfo, TinySliderInstance } from '../../../node_modules/tiny-slider/src/tiny-slider';
import { BevviAD } from '../shared/interfaces/bevviad';
import { AccountReponseData } from '../shared/interfaces/account';
import { OfferResponseData, OffersAllPageResponseData, OfferFilterCategoryInterface, LocalStorageOfferData } from '../shared/interfaces/offer';
import { CustomjsService } from '../shared/service/customjs.service';
import { CitiesRoute } from '../shared/interfaces/states';


@Component({
  selector: 'bevvi-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss', './home-paccontainer.component.scss', './coupon-modal.component.scss']
})
export class HomeComponent implements OnInit {

  createCouponForm: FormGroup;

  public appLink: string = IOS_APP_LINK;
  public latitude: number;
  public longitude: number;
  @ViewChild('searchMap', {static: true})
  public searchElementRef: ElementRef;

  public errorMsg: string;

  public formattedAddress: string;
  public addressError: boolean = false;
  public loading: boolean = false;
  public userSearchDeliveryInfo: UserSearchDeliveryLocationInfo;
  public address: any;
  @Output() quantityValue: number;

  @ViewChild('coupon', {static: false})
  public couponRef: ElementRef;

  @ViewChild('couponDismiss', {static: false})
  public couponDismissRef: ElementRef;

  @ViewChild('refresh', {static: false})
  public refreshRef: ElementRef;

  public cartQty: number = 0;
  private isSubmit: boolean = true;
  public formSubmit: boolean = false;
  private notUse: boolean = false;
  private seoBreadCrumbSet: boolean = false;
  private seoBreadCrumbList: any;
  private googleAnalyticID: string = GOOGLE_ANALYTIC_ID;
  public webLink = WEB_LINK + '';
  private gaScriptPageViews: any;
  private remarkety_popup: any;
  private remarketyPopSet: boolean = false;
  public establishmentIdData: any;
  private oldEstablishmentIDData: any;
  public citi_route:boolean = false;
  public city: string;
  public userAddress: object = {};
  public isLoggedIn: boolean = false;
  public isLocationPresent: boolean = false;
  public wineOffer: OfferFilterCategoryInterface = {
    category: 'Wine',
    filters: '"price":["$50+"]',
    source: 'Home'
  }
  public wineAbove30Offer: OfferFilterCategoryInterface = {
    category: 'Wine',
    filters: '"price":["$30 - $40"]',
    source: 'Home'
  }
  public winKitsOffer: OfferFilterCategoryInterface = {
    category: 'All',
    filters: '"subCategory":["Wine Kits", "Cocktail Kit"]',
    source: 'Home'
  }
  public beerOffer: OfferFilterCategoryInterface = {
    category: 'Beer',
    filters: '',
    source: 'Home'
  }
  public liquorOffer: OfferFilterCategoryInterface = {
    category: 'Liquor',
    filters: '"price":["$50+"]',
    source: 'Home'
  }
  public liquorAbove30Offer: OfferFilterCategoryInterface = {
    category: 'Liquor',
    filters: '"price":["$30 - $40"]',
    source: 'Home'
  }
  public mixerOffer: OfferFilterCategoryInterface = {
    category: 'Mixer',
    filters: '',
    source: 'Home'
  }
  public holidayOffer: OfferFilterCategoryInterface = {
    category: 'All',
    filters: '',
    source: 'Home'
  }
  public establishmentId: string;
  private isLocationChange: boolean = false;

  // Bevvi AD Feature
  public showADs: boolean = false;
  private slider: TinySliderInstance;
  private numOfBanner: number = 3;
  private storeIndexTrack: Array<number> = [];
  public monthLine = 'Our picks for ';
  public monthArray = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'];
  public presentMonth;
  public adsArray: any;
  public imageUrl = 'https://bevvi.s3.us-east-2.amazonaws.com/'

  constructor(
    private apiService: ApiService,
    private localStorage: LocalStorageService,
    private userService: UserService,
    private ngZone: NgZone,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private titleService: Title,
    private meta: Meta,
    private customJS: CustomjsService
  ) { }

  ngOnInit() {

    this.userService.topBannerChange('SEND YOUR FAVORITE DRINKS TO YOUR TEAM OR CLIENTS, NO MINIMUM !!!!!');
    window.scrollTo(0,0);
    this.presentMonth = this.monthArray[new Date().getMonth()];
    // try {
    //   let autoComplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
    //     types: ["address"]
    //   });

    //   autoComplete.addListener("place_changed", () => {
    //     let place: google.maps.places.PlaceResult = autoComplete.getPlace();

    //     if (place.geometry === undefined || place.geometry === null) {
    //       return;
    //     }
    //     this.latitude = place.geometry.location.lat();
    //     this.longitude = place.geometry.location.lng();
    //     this.formattedAddress = place.formatted_address;
    //     // console.log('Place Changed');
    //     // console.log(place);

    //     place.address_components.forEach(data => {
    //       let type = data.types[0];
    //       let shortName = data.short_name;
    //       this.userAddress[type] = shortName
    //     })
    //     this.isLocationChange = true;
    //     this.clickShopNow();
    //   });
    // } catch {
    //   // this.refreshRef.nativeElement.click();
    // }

    this.cartQty = this.localStorage.getCartQuantityFromLocalStorage() ? this.localStorage.getCartQuantityFromLocalStorage() : 0;
    // this.calculateSubTotal();
    this.userService.cartQty$
    .subscribe(
      (cartQty: number) => {
        this.cartQty = cartQty;
      }
    );

    let userSavedGeoLocationAddress: UserSearchDeliveryLocationInfo['address'] = this.localStorage.getUserSearchGeoLocationAddress() ? this.localStorage.getUserSearchGeoLocationAddress() : null;
    let userSavedGeoLocationPoint: UserSearchDeliveryLocationInfo['geoLocation'] = this.localStorage.getUserSearchGeoLocationPoint() ? this.localStorage.getUserSearchGeoLocationPoint() : null;
    if (userSavedGeoLocationAddress && userSavedGeoLocationPoint) {
      // console.log('Address is already stored in Local Storage');
      this.longitude = userSavedGeoLocationPoint['coordinates'][0];
      this.latitude = userSavedGeoLocationPoint['coordinates'][1];

      this.formattedAddress = userSavedGeoLocationAddress;
      // this.searchElementRef.nativeElement.value = this.formattedAddress;
      this.address = this.formattedAddress;
    }

    let isLocalDataPresent = this.localStorage.getCartQuantityFromLocalStorage() ? true : false;
    if (isLocalDataPresent) {
      this.loading = false;
      this.addressError = false;
      this.errorMsg = "Please enter a valid address and select from dropdown to access Cart";
    }

    this.initForm();
    this.isLoggedIn = this.localStorage.isLoggedIn();

    this.gaScriptPageViews = this._renderer2.createElement('script');
    this.gaScriptPageViews.text = 'text/javascript';
    this.gaScriptPageViews.id = 'ga-track-pageviews';
    this.gaScriptPageViews.async = true;
    this.gaScriptPageViews.defer = true;

    this.gaScriptPageViews.text = `gtag('config', '${this.googleAnalyticID}', {
        'page_title': 'home',
        'page_path': '/'
    })`;

    this._renderer2.appendChild(this._document.body, this.gaScriptPageViews);
    this.titleService.setTitle(MAIN_TITLE);
    this.meta.updateTag({name: "description", content:DESCRIPTION});

    this.route.data.subscribe(
      (data: CitiesRoute) => {
        if (data.alabama) {this.citi_route = true;this.city = 'Alabama';}
        else if (data.arizona) {this.citi_route = true;this.city = 'Arizona';} 
        else if (data.arkansas) {this.citi_route = true;this.city = 'Arkansas';}
        else if (data.california) {this.citi_route = true;this.city = 'California';} 
        else if (data.colorado) {this.citi_route = true;this.city = 'Colorado';} 
        else if (data.connecticut) {this.citi_route = true;this.city = 'Connecticut';} 
        else if (data.delaware) {this.citi_route = true;this.city = 'Delaware';} 
        else if (data.florida) {this.citi_route = true;this.city = 'Florida';} 
        else if (data.georgia) {this.citi_route = true;this.city = 'Georgia';} 
        else if (data.idaho) {this.citi_route = true;this.city = 'Idaho';} 
        else if (data.illinois) {this.citi_route = true;this.city = 'Illinois';} 
        else if (data.indiana) {this.citi_route = true;this.city = 'Indiana';} 
        else if (data.iowa) {this.citi_route = true;this.city = 'Iowa';} 
        else if (data.kansas) {this.citi_route = true;this.city = 'Kansas';} 
        else if (data.kentucky) {this.citi_route = true;this.city = 'Kentucky';} 
        else if (data.louisiana) {this.citi_route = true;this.city = 'Louisiana';} 
        else if (data.maine) {this.citi_route = true;this.city = 'Maine';} 
        else if (data.maryland) {this.citi_route = true;this.city = 'Maryland';} 
        else if (data.massachusetts) {this.citi_route = true;this.city = 'Massachusetts';} 
        else if (data.michigan) {this.citi_route = true;this.city = 'Michigan';} 
        else if (data.minnesota) {this.citi_route = true;this.city = 'Minnesota';} 
        else if (data.mississippi) {this.citi_route = true;this.city = 'Mississippi';} 
        else if (data.missouri) {this.citi_route = true;this.city = 'Missouri';} 
        else if (data.montana) {this.citi_route = true;this.city = 'Montana';} 
        else if (data.nebraska) {this.citi_route = true;this.city = 'Nebraska';} 
        else if (data.nevada) {this.citi_route = true;this.city = 'Nevada';} 
        else if (data.new_hampshire) {this.citi_route = true;this.city = 'New Hampshire';} 
        else if (data.new_jersey) {this.citi_route = true;this.city = 'New Jersey';} 
        else if (data.new_mexico) {this.citi_route = true;this.city = 'New Mexico';} 
        else if (data.new_york) {this.citi_route = true;this.city = 'New York';} 
        else if (data.north_carolina) {this.citi_route = true;this.city = 'North Carolina';} 
        else if (data.north_dakota) {this.citi_route = true;this.city = 'North Dakota';} 
        else if (data.ohio) {this.citi_route = true;this.city = 'Ohio';} 
        else if (data.oklahoma) {this.citi_route = true;this.city = 'Oklahoma';} 
        else if (data.oregon) {this.citi_route = true;this.city = 'Oregon';} 
        else if (data.pennsylvania) {this.citi_route = true;this.city = 'Pennsylvania';} 
        else if (data.rhode_island) {this.citi_route = true;this.city = 'Rhode Island';} 
        else if (data.south_carolina) {this.citi_route = true;this.city = 'South Carolina';} 
        else if (data.south_dakota) {this.citi_route = true;this.city = 'South Dakota';} 
        else if (data.tennessee) {this.citi_route = true;this.city = 'Tennessee';} 
        else if (data.texas) {this.citi_route = true;this.city = 'Texas';} 
        else if (data.vermont) {this.citi_route = true;this.city = 'Vermont';} 
        else if (data.virginia) {this.citi_route = true;this.city = 'Virginia';} 
        else if (data.washington) {this.citi_route = true;this.city = 'Washington';} 
        else if (data.washington_dc) {this.citi_route = true;this.city = 'Washington DC';} 
        else if (data.west_virginia) {this.citi_route = true;this.city = 'West Virginia';} 
        else if (data.wisconsin) {this.citi_route = true;this.city = 'Wisconsin';} 
        else if (data.wyoming) {this.citi_route = true;this.city = 'Wyoming';}
        else {
          this.citi_route = false;
          this.city = '';
        }
        if (this.citi_route) {
          this.titleService.setTitle(this.city + ' | ' + MAIN_TITLE);
          this.meta.updateTag({name:"description",content:`Bevvi makes corporate gifting of alcohol seamless. Send your favorite drinks to your team or clients in ${this.city}, no minimum!!!!!`})
        }
      }
    )

    this.apiService.getData(this.apiService.constants.GET_BEVVI_AD, {"receipt":false}, true)
    .subscribe(
      (bevviAd: BevviAD) => {
        if (bevviAd.showAds === true) {
          this.showADs = true;
          this.customJS.loadSlider();
          this.adsArray = bevviAd.corpMainAdsArray;
          // console.log(this.adsArray);
        } else {
          this.showADs = false;
        }
        // this.showADs = false;
      }
    );

    // if (ENV_TYPE === 'development') {
    //   // this.remarketyPopUp();
    // }

    // this.slider = tns({
    //   container: '.my-slider',
    //   items: 5,
    //   slideBy: 'page',
    //   autoplay: true,
    //   gutter: 5,
    //   controls: false,
    //   speed: 400,
    //   swipeAngle: false,
    //   autoWidth: true,
    //   fixedWidth: false,
    //   mouseDrag: true,
    //   loop: true,
    //   autoplayButton: false,
    //   // autoplayTimeout: 10000,
    //   autoplayButtonOutput: false,
    //   autoplayHoverPause: true,
    //   lazyload: true,
    //   responsive: {
    //     "1920": {
    //       fixedWidth: 1920
    //     },
    //     "1400": {
    //       fixedWidth: 1400
    //     },
    //     "1366": {
    //       fixedWidth: 1366
    //     },
    //     "1024": {
    //       fixedWidth: 1024,
    //     },
    //     "823": {
    //       fixedWidth: 823
    //     },
    //     "812": {
    //       fixedWidth: 812
    //     },
    //     "768": {
    //       fixedWidth: 768
    //     },
    //     "736": {
    //       fixedWidth: 736
    //     },
    //     "731": {
    //       fixedWidth: 731
    //     },
    //     "667": {
    //       fixedWidth: 667
    //     },
    //     "640": {
    //       fixedWidth: 640
    //     },
    //     "568": {
    //       fixedWidth: 568
    //     },
    //     "450": {
    //       fixedWidth: 450
    //     },
    //     "414": {
    //       fixedWidth: 414
    //     },
    //     "411": {
    //       fixedWidth: 411
    //     },
    //     "375": {
    //       fixedWidth: 375
    //     },
    //     "360": {
    //       fixedWidth: 360
    //     },
    //     "320": {
    //       fixedWidth: 320
    //     }
    //   }
    // });

    this.isLocationPresent = (this.localStorage.getUserSearchGeoLocationAddress()) ? true : false;
    // let establishmentDataObject: object = this.localStorage.getEstablishmentIDofAddress();
    // this.establishmentId = establishmentDataObject['establishmentId']
    // this.userService.changeLocationAddress$
    // .subscribe(
    //   (changeLocation: boolean) => {
    //     if (changeLocation) {
    //       let establishmentDataObject: object = this.localStorage.getEstablishmentIDofAddress();
    //       this.establishmentId = establishmentDataObject['establishmentId']
    //     }
    //   }
    // )
  }

  initForm() {
    // Coupon Form
    this.createCouponForm = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.minLength(5)]]
    });
  }

  // ngAfterViewInit() {
  //   // console.log('CLicked')
  //   // if (!this.localStorage.getCouponModal() && !(this.localStorage.isLoggedIn())) {
  //   //   this.couponRef.nativeElement.click();
  //   // }
  // }

  get couponEmail() {
    return this.createCouponForm.get('email');
  }

  breadCrumbList() {
    if (this.seoBreadCrumbSet) {
      this._renderer2.removeChild(this._document.head, this.seoBreadCrumbList);
    }
    this.seoBreadCrumbSet = true;
    this.seoBreadCrumbList = this._renderer2.createElement('script');
    this.seoBreadCrumbList.type = 'application/ld+json';
    // this.seoBreadCrumbList.id = '';
    // this.seoBreadCrumbList.async = 'true';
    // this.seoBreadCrumbList.defer = 'true';


    this.seoBreadCrumbList.text = `{
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
        "itemListElement": [{
          "@type": "ListItem",
          "position": 1,
          "item": {
            "@id": "/",
            "name": "Bevvi"
          }
        }]
    }`;

    this._renderer2.appendChild(this._document.head, this.seoBreadCrumbList);
  }

  clickShopNow() {

    this.loading = true;
    // console.log(this.userAddress)
    // console.log('Clicked');
    // console.log('Loading' + this.loading);
    // console.log('Latitude: '+ this.latitude )
    // console.log('Longitude: '+ this.longitude )
    // return;
    if (this.isLocationChange) {
      if ( this.latitude != null || this.longitude != null ) {
        this.addressError = false;
        this.userSearchDeliveryInfo = {
          "geoLocation": {
            "coordinates": [
              this.longitude,
              this.latitude
            ],
            "type": "Point"
          },
          "address": this.formattedAddress
        };
        let stateName;
        let zipCode;
        Object.keys(this.userAddress).forEach((key) => {
          if (key === 'administrative_area_level_1') {
            stateName = this.userAddress[key]
          } else if (key === 'postal_code') {
            zipCode = this.userAddress[key]
          }
          if (key === 'administrative_area_level_1') {
            if (this.userAddress[key] === 'CA') {
              this.localStorage.setCaliforniaProposition(true);
            } else {
              this.localStorage.setCaliforniaProposition(false);
            }
          }
        })

        let updateData = {
          addressComponent: this.userAddress
        }
        this.oldEstablishmentIDData = this.localStorage.getEstablishmentIDofAddress();
        if (this.localStorage.isLoggedIn()) {
          // Get Delivery Location ID
          let deliveryData = {
            "accountId": this.localStorage.getCurrentAccountID(),
            // "locationId": locationData.id,
            "geoLocation": {
              "coordinates": [
                this.longitude,
                this.latitude
              ],
              "type": "Point"
            },
            "address": this.formattedAddress
          };
          // console.log(deliveryData);

          let param = {
            "currentAccountId": this.localStorage.getCurrentAccountID(),
            "accessToken": this.localStorage.getAccessToken()
          }
          this.apiService.putData(this.apiService.constants.ACCOUNT_DATA_API, updateData, param, true)
          .subscribe(
            (accountResponseData: AccountReponseData) => {
              this.localStorage.setUserAddressComponent(updateData);
              this.apiService.postData(this.apiService.constants.UPDATE_ACCOUNT_ON_REMARKETY, '', param, true)
              .subscribe();
            }
          )

          this.apiService.postData(this.apiService.constants.ADD_DELIVERY_LOCATION_API, deliveryData, {}, false)
          .subscribe(
            (deliveryLocationData: DeliveryLocationResponseData) => {
              this.localStorage.setUserSearchGeoLocationAddress(deliveryLocationData.address);
              this.localStorage.setUserSearchGeoLocationPoint(deliveryLocationData.geoLocation);
              let params = {
                geoLocationParams: JSON.stringify(this.userSearchDeliveryInfo.geoLocation),
                currentAccountId: this.localStorage.getCurrentAccountID(),
                stateName: stateName,
                zipCode: zipCode
              }
              // this.userService.locationAddress(true);


              this.userService.locationInfo(true);
              this.apiService.getData(this.apiService.constants.GET_ESTABLISHMENTID_BYACCOUNTID, params, true)
              .subscribe(
                (data) => {
                  // this.oldEstablishmentIDData = this.localStorage.getEstablishmentIDofAddress();
                  this.localStorage.setEstablishmentIDofAddress(data)
                  this.establishmentIdData = data;
                  this.syncLocalCart();
                  this.ngZone.run(() => {
                    this.router.navigate(['/productlisting']);
                  });
                },
                error => {
                  console.log(error)
                }
              )
              // this.ngZone.run(() => {
              //   this.router.navigate(['/productlisting']);
              // });
            },
            error => {
              this.loading = false;
              this.errorHandle(error);
            }
          );
        } else {
          this.localStorage.setUserSearchGeoLocationPoint(this.userSearchDeliveryInfo.geoLocation);
          this.localStorage.setUserSearchGeoLocationAddress(this.userSearchDeliveryInfo.address);
          this.userService.locationInfo(true);
          // this.userService.locationAddress(true);

          this.localStorage.setUserAddressComponent(updateData);
          this.localStorage.setUserDeliveryLocation(true);
          // console.log('Redirect to ProductListing');
          // this.loading = false;
          let params = {
            geoLocationParams: JSON.stringify(this.userSearchDeliveryInfo.geoLocation),
            stateName: stateName,
            zipCode: zipCode
          }
          this.apiService.getData(this.apiService.constants.GET_ESTABLISHMENTID_BYGEOLOCATION, params, true)
          .subscribe(
            (data) => {
              // this.oldEstablishmentIDData = this.localStorage.getEstablishmentIDofAddress();
              this.localStorage.setEstablishmentIDofAddress(data)
              this.establishmentIdData = data;
              this.syncLocalCart();
              this.ngZone.run(() => {
                this.router.navigate(['/productlisting']);
              });
            },
            error => {
              console.log(error);
            }
          )

        }
      } else {
        this.loading = false;
        this.addressError = true;
        this.errorMsg = "Please enter a valid address and select from dropdown.";
      }

    } else {
      this.loading = false;
      this.router.navigate(['/productlisting'])
    }
  }

  syncLocalCart() {
    // console.log('CALLED SYNC CART')
    if (this.localStorage.getCartQuantityFromLocalStorage() > 0) {
      if (Object.entries(this.oldEstablishmentIDData).length > 0) {
        let keepRecordID = '';
        Object.keys(this.oldEstablishmentIDData).map((id) => {
          // console.log(this.oldEstablishmentIDData[id]);
          if (this.oldEstablishmentIDData[id] === this.establishmentIdData['establishmentId']) {
            keepRecordID = this.establishmentIdData['establishmentId'];
          } else if (this.oldEstablishmentIDData[id] === this.establishmentIdData['otherEstablishmentId']) {
            keepRecordID = this.establishmentIdData['otherEstablishmentId'];
          }
        });
        // console.log('RECORD TO KEEP' + keepRecordID);
        if (keepRecordID != '') {
          let oldOfferCart: Array<LocalStorageOfferData> = this.localStorage.getShoppingCartData();
          let offerCart: Array<LocalStorageOfferData> = [];
          this.localStorage.unsetShoppingCartData();
          oldOfferCart.forEach(function(cart) {
            if (cart.establishmentId === keepRecordID) {
              offerCart.push(cart);
              // console.log(cart);
            }
          });
          if (offerCart.length > 0) {
            this.localStorage.setShoppingCartData(offerCart);
          }
          this.userService.loadCartQty(this.localStorage.getCartQuantityFromLocalStorage());
        } else {
          this.localStorage.unsetShoppingCartData();
          this.userService.loadCartQty(this.localStorage.getCartQuantityFromLocalStorage());
        }
      } else {
        this.localStorage.unsetShoppingCartData();
        this.userService.loadCartQty(this.localStorage.getCartQuantityFromLocalStorage());
      }
      this.oldEstablishmentIDData = {};
    }
  }

  /**
   * Update Address
   */
  updateAddress() {
    if (this.searchElementRef.nativeElement.value != null && this.addressError) {
      this.addressError = false;
    }
    this.latitude = null;
    this.longitude = null;
  }

  /**
   * Error Handle Function
   * @param error
   * @return void
   */
  errorHandle(error): void {
    this.addressError = true;
    if (error.status === 0) {
      this.errorMsg = "Please check your internet connection."
    } else if (error.status === 422) {
      this.errorMsg = "Validation error, try again.";
    } else {
      this.errorMsg = "Server Error, please refresh the page and try again."
    }
  }

  submitEmailForCoupon() {
    // console.log('Submitting coupon');
    if (this.isSubmit && !this.notUse) {
      this.isSubmit = !this.isSubmit;
      if (this.createCouponForm.invalid) {
        // console.log(this.createCouponForm.invalid)
        this.isSubmit = !this.isSubmit;
        this.formSubmit = true;
        return;
      }
      let email: string = this.createCouponForm.value['email'];

      if (email) {
        let data = {
          userType: 'coupon',
          email: email,
        };

        this.apiService.postData(this.apiService.constants.SUBSCRIBE_NEWSLETTER, data, '', false)
          .subscribe(data => {
            // console.log(data);
            this.createCouponForm.reset();
            this.couponDismissRef.nativeElement.click();
            this.localStorage.setCoupnModal(1);
          })
      }
    }
  }

  remarketyPopUp() {
    this.remarketyPopSet = true;
    this.remarkety_popup = this._renderer2.createElement('script');
    this.remarkety_popup.id = `remarkety`;
    this.remarkety_popup.async = true;
    this.remarkety_popup.defer = true;

    this.remarkety_popup.text = `
        var RID="845eWQ4q";var RFID="Wx4AwXdr";
        function loadScript(src, callback) {
            var s,r,t;r = false;s = document.createElement('script');
            s.type = 'text/javascript';s.src = src;
            s.onload = s.onreadystatechange = function(){
                if (!r && (!this.readyState || this.readyState == 'complete')){r = true;callback();}
            };t = document.getElementsByTagName('script')[0];t.parentNode.insertBefore(s, t); }
        loadScript("https://d3ryumxhbd2uw7.cloudfront.net/popup/popup.min.js", function(){});
    `;

    this._renderer2.appendChild(this._document.body, this.remarkety_popup);
  }

  goToCart() {
    this.router.navigate(['/recipient']);
  }

  ngOnDestroy() {
    if (this.seoBreadCrumbSet) {this._renderer2.removeChild(this._document.head, this.seoBreadCrumbList);}

    if (this.userService.setCategoryView != 'all') {
      this.userService.setCategoryView = 'all';
    }

    this._renderer2.removeChild(this._document.body, this.gaScriptPageViews);

    if (this.remarketyPopSet) {
      this._renderer2.removeChild(this._document.body, this.remarkety_popup);
    }
  }

}
